/**
 * The title of the newsletters in the response is extended with the periodicity separated by a vertical line: '|'.
 * For example: "Newsletter Name | Weekly".
 * This function extracts either the name or the period from the newsletter title based on the provided detail parameter.
 *
 * @param {Object} newsletter - The newsletter object containing the title.
 * @param {"name" | "period"} detail - The detail to extract: "name" for the newsletter name, "period" for the periodicity.
 * @returns {string | null} - The extracted name or period, or null if not found.
 */
export const getNewsletterDetail = (newsletter: { title: string }, detail: 'title' | 'period') => {
  // Check if the newsletter or title is undefined or not a string
  if (!newsletter || typeof newsletter.title !== 'string') {
    return null; // or throw an error depending on your needs
  }

  const title = newsletter.title.trim();
  const hasVerticalLine = title.includes('|');

  if (hasVerticalLine) {
    const parts = title.split('|').map((part) => part.trim());

    // Return the requested detail based on the 'detail' parameter
    if (detail === 'title') {
      return parts[0] || null; // handle cases where there is no name before the |
    } else if (detail === 'period') {
      return parts[1] || null; // handle cases where there is no period after the |
    }
  } else {
    // If no vertical line is present
    return detail === 'title' ? title : null; // Return name if requested, otherwise null
  }

  return null; // Default return value if none of the conditions are met
};
